import styled from "@emotion/styled";
import { motion } from "framer-motion";
import React from "react";

export default function LoadingRow(): JSX.Element {
  const LoadingContainer = styled.div`
    width: 100%;
    height: 5px;
    background-color: #fb982e52;
    position: relative;
    overflow: hidden;
    margin-top: 20px;
  `;

  const StyledLoading = styled(motion.div)`
    width: 50%;
    height: 5px;
    background-color: #fb972e;
    position: absolute;
    left: -50%;
  `;

  return (
    <LoadingContainer>
      <StyledLoading
        animate={{ left: "100%" }}
        transition={{
          repeat: Infinity,
          repeatDelay: 0.5,
          repeatType: "loop",
          duration: 1,
        }}
      />
    </LoadingContainer>
  );
}
